import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=469be080&scoped=true"
import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"
import style0 from "./redirect.vue?vue&type=style&index=0&id=469be080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469be080",
  null
  
)

export default component.exports